import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

import style from './style'

export class Slideshow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      slides: props.slides.map((item, index) => ({
        ...item,
        active: !!(index === 0)
      }))
    }
  }

  componentDidMount () {
    this.setSlideTimeout()
  }

  setSlideTimeout () {
    this._timeout = setTimeout(() => {
      this.setState({
        ...this.state,
        slides: this.state.slides.map((item, index, arr) => ({
          ...item,
          active: !!(index === 0
            ? arr[arr.length - 1].active
            : arr[index - 1].active)
        }))
      })

      this.setSlideTimeout()
    }, this.props.timeout)
  }

  onControlsClick (next) {
    if (this._timeout) {
      clearTimeout(this._timeout)
    }

    this.setState({
      ...this.state,
      slides: this.state.slides.map((item, index, arr) => ({
        ...item,
        active: !next
          ? !!(index === arr.length - 1 ? arr[0].active : arr[index + 1].active)
          : !!(index === 0 ? arr[arr.length - 1].active : arr[index - 1].active)
      }))
    })

    this.setSlideTimeout()
  }

  render () {
    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height
        }}
        className={css(style.main.wrapper)}
      >
        <button
          onClick={this.onControlsClick.bind(this, false)}
          className={css(style.controls.button, style.controls.backwards)}
        >
          <i className='fa fa-angle-left' />
        </button>
        <button
          onClick={this.onControlsClick.bind(this, true)}
          className={css(style.controls.button, style.controls.forward)}
        >
          <i className='fa fa-angle-right' />
        </button>
        <ul
          style={{
            width: this.props.width,
            height: this.props.height
          }}
          className={css(style.main.list, style.image.list)}
        >
          {this.state.slides.map((item, index) => (
            <RenderImageSlide
              key={index}
              url={item.imageUrl}
              hide={!item.active}
              content={item.content}
              component={item.component}
            />
          ))}
        </ul>
      </div>
    )
  }
}

const RenderImageSlide = props => {
  return (
    <li
      className={`${css(
        style.image.listItem,
        style.animation.fadeOut,
        props.hide ? style.animation.fadeOutHide : null
      )}`}
      style={{ backgroundImage: `url(${props.url})` }}
    >
      {props.component
        ? props.component
        : Array.isArray(props.content)
          ? RenderArrayContent({ content: props.content, active: !props.hide })
          : RenderImageContnent({ ...props.content, active: !props.hide })}
    </li>
  )
}

const RenderArrayContent = props => (
  <Container className={`d-flex ${css(style.image.contentContainer)}`}>
    <Row>
      {props.content.map((contentItem, index) => (
        <Col key={index}>
          <RenderImageColumn
            content={Array.isArray(contentItem) ? contentItem : [contentItem]}
            active={props.active}
          />
        </Col>
      ))}
    </Row>
  </Container>
)

const RenderImageContnent = props => (
  <Container className={`d-flex ${css(style.image.contentContainer)}`}>
    <Row>
      <Col
        className={`d-flex align-items-center ${css(
          style.image.contentLeftColumn,
          props.active ? style.image.contentLeftColumnActive : null
        )}`}
      >
        <RenderImageColumn content={props.left} active={props.active} />
      </Col>
      <Col className={`d-flex align-items-center`}>
        <RenderImageColumn content={props.right} active={props.active} />
      </Col>
    </Row>
  </Container>
)

const RenderImageColumn = props => {
  if (!props.content) {
    return null
  }

  const headerList = props.content.filter(item => item.type === 'header')
  const subheaderList = props.content.filter(item => item.type === 'subheader')
  const descList = props.content.filter(item => item.type === 'desc')
  const buttonList = props.content.filter(item => item.type === 'button')
  const imageList = props.content.filter(item => item.type === 'image')

  return (
    <Row>
      {headerList.map((item, index) => (
        <Col xs='12' key={`header${index}`}>
          <h2 className={css(style.image.contentHeader)}>{item.content}</h2>
        </Col>
      ))}

      {subheaderList.map((item, index) => (
        <Col
          xs='12'
          key={`subheader${index}`}
          className={css(
            style.image.contentSubheaderBox,
            props.active ? style.image.contentSubheaderBoxActive : null,
            item.animation ? style.animation[item.animation] : null
          )}
        >
          <span className={css(style.image.contentSubheader)}>
            {item.content}
          </span>
        </Col>
      ))}

      {descList.map((item, index) => (
        <Col
          xs='12'
          key={`desc${index}`}
          className={css(
            style.image.contentDescBox,
            props.active ? style.image.contentDescBoxActive : null,
            item.animation ? style.animation[item.animation] : null
          )}
        >
          <span className={css(style.image.contentDesc)}>{item.content}</span>
        </Col>
      ))}

      {buttonList.length > 0 && (
        <Col xs='12' className={css(style.image.contentButtonBox)}>
          <Row>
            {buttonList.map((item, index) => (
              <Col
                xs={index === 0 ? `3` : `4`}
                key={`button${index}`}
                className={css(
                  style.image.contentButtonWrapper,
                  item.animation ? style.animation[item.animation] : null
                )}
              >
                <Link
                  to={item.url}
                  className={`d-block ${css(
                    style.image.contentButton,
                    item.color === 'red'
                      ? style.image.contentButtonRed
                      : style.image.contentButtonWhite
                  )}`}
                >
                  {item.title}
                </Link>
              </Col>
            ))}
          </Row>
        </Col>
      )}

      {imageList.length > 0 && (
        <Col
          xs='12'
          className={css(
            imageList[0].animation
              ? style.animation[imageList[0].animation]
              : null,
            props.active ? style.animation.transformActive : null
          )}
        >
          <img src={imageList[0].src} style={{ maxWidth: `100%` }} />
        </Col>
      )}
    </Row>
  )
}

Slideshow.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  slides: PropTypes.array.isRequired,
  timeout: PropTypes.number.isRequired
}

export default Slideshow



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/index.js